module.exports = __webpack_public_path__ + "media/accept-change.3d9665cb.svg";